import { render } from "./editarNota.vue?vue&type=template&id=7b821bc1&scoped=true"
import script from "./editarNota.vue?vue&type=script&lang=js"
export * from "./editarNota.vue?vue&type=script&lang=js"

import "./editarNota.vue?vue&type=style&index=0&id=7b821bc1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b821bc1"]])

export default __exports__